import React from "react";

import { BtnThanhToan } from "./ChucNang/ThanhToan/BtnThanhToan";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietKhachhang } from "./ChiTietKhachHang/BtnChiTietKhachhang";
import { formatNumber } from "utils/currencyFormat";
import { BtnChiTietTaiSan } from "./BtnChiTietTaiSan";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";
import { BtnChiTietDaTra } from "./ChucNang/chiTietDaTra/BtnChiTietDaTra";

export const ContentTable = ({ listCongNoFull, quyenXoa, quyenThanhToan }) => {
  return listCongNoFull.map((item, index) => (
    <div className="custom-table-row" key={"item" + 1}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.STT}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-12-2-sm">
        <span className="mobile-column-name">Mã</span>
        <div className="center-wrapper">
          <p className="text-center color7  word-break">{item.ThanhLyCode}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-11-sm">
        <span className="mobile-column-name">Khách hàng</span>
        <div className="center-wrapper color7">
          <p className="text-left color-xanh-bold">
            {/* <BtnChiTietKhachhang item={item} /> */}
            {item.TenKhachhang}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-11-6-sm">
        <span className="mobile-column-name">Tên tài sản</span>
        <div className="center-wrapper color7">
          <p>
            <BtnChiTietTaiSan taisan={item} />
            <br />
            {item.TenTaiSan}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
        <span className="mobile-column-name">Mã hợp đồng</span>
        <div className="center-wrapper color7">
          <p className="text-center">
            <BtnChiTietHopDong item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-12-8-sm">
        <span className="mobile-column-name">Tiền thanh lý</span>
        <div className="center-wrapper color7">
          <p className="text-right color-do-bold">
            {formatNumber(item.TienThanhLy + item.PhiKhac)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-12-8-sm">
        <span className="mobile-column-name">Đã trả</span>
        <div className="center-wrapper color7">
          <p className="text-right">
            <BtnChiTietDaTra item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-12-sm">
        <span className="mobile-column-name">Còn nợ</span>
        <div className="center-wrapper color7-bold">
          <p className="text-right color-cam">
            {formatNumber(item.TienThanhLy + item.PhiKhac - item.TienDaTra)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-8-6-sm  action-cell">
        <div className="center-wrapper color7">
          <div className="iconTableMormanCenter">
            {quyenThanhToan && <BtnThanhToan item={item} />}
            {quyenXoa && <BtnXoa item={item} />}
          </div>
        </div>
      </div>
    </div>
  ));
};
